import { ActivityPageFieldVisibility, Client, VATRate } from '../types/GrooverTypes'

export const DEFAULT_VAT_RATE: VATRate = 25

export const getDefaultVatRate = (client: Client | null | undefined): VATRate => {
  return client?.defaultVAT ?? DEFAULT_VAT_RATE
}

export const DEFAULT_ACTIVITY_PAGE_FIELD_VISIBILITY: ActivityPageFieldVisibility = {
  showLocation: true,
  showRoom: true,
  showGoogleLinkAndMap: true,
  showOccasions: true,
  showOtherActivitiesAndEvents: true,
  showPrice: true,
  showDropinPrice: true,
  showInstructors: true
}

export const resolveActivityPageFieldVisibility = (client: Client | null | undefined): ActivityPageFieldVisibility => ({
  ...DEFAULT_ACTIVITY_PAGE_FIELD_VISIBILITY,
  ...(client?.activityPageFieldVisibility ?? {})
})
